module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA+klEQVQ4jZ3TvUrEUBAF4C/ZLbQTfAELwT/QQntBEOxFQVDZcjsb38HOF7AU7ezsRVuxEFYQkVRarYKd4g+xSCIx5KLZU517Z86ZGe7cKE2EsIjjnG/goi4pChi0cIvx/HyPSXxVE+NA9bWSWM7X/9tBC1eYq9z3MI/3qkEbK5jFBBYwHejsDpey8Xo4jdLEITYDgr9wFKWJVwwNaPAW43xAMZzF2JLN0xTX2I7RxxJuGoh7WMZTsQd9dBsYdHPNr0VqNzAYLkjZIPT2dZiqM5hpYPBTrNz2ZyXpBfs538FoKfZRkPJfGMOJ7OMcYA/PeWwEu+jgEat4gG+7VjPyDw5B6wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/1星.png
// module id = YA7w
// module chunks = 1